import { Camera } from 'lucide-react'

import { useCallback, useState } from 'react'

import { cn } from '@/lib/utils'

import { CameraScanner } from './CameraScanner'

interface CameraScanButtonProps {
  onScan: (code: string) => void
  /** Keep the camera open after a read (selling). */
  continuous?: boolean
  className?: string
}

/** The camera icon beside any scan field; reads QR or barcode, whichever is shown (POS.md §18.8). */
export const CameraScanButton = ({ onScan, continuous, className }: CameraScanButtonProps) => {
  const [anchor, setAnchor] = useState<DOMRect | null>(null)
  const close = useCallback(() => setAnchor(null), [])

  return (
    <>
      <button
        type="button"
        onClick={(e) => setAnchor(anchor ? null : e.currentTarget.getBoundingClientRect())}
        aria-label={anchor ? 'Close camera scanner' : 'Scan with the camera'}
        aria-pressed={!!anchor}
        title="Scan with the camera"
        className={cn(
          'grid size-7 shrink-0 place-items-center rounded-xs text-muted-foreground transition-colors hover:bg-fill hover:text-ink',
          anchor && 'bg-fill text-ink',
          className
        )}
      >
        <Camera className="size-5" />
      </button>
      {anchor && <CameraScanner anchor={anchor} onScan={onScan} onClose={close} continuous={continuous} />}
    </>
  )
}
